export default __webpack_public_path__ + "static/media/sam_f.9113fd8f.png";